import { UpgradeBanner } from '@/components';
import CustomLayoutOneThird from '@/components/CustomLayoutOneThird';
import { AccountPlan } from '@/constants/enum';
import { accountSelector } from '@/redux/features/plan.slice';
import { BlockStack, Text } from '@shopify/polaris';
import { useSelector } from 'react-redux';
import MaskingRules from './components/MaskingRules';
import { CarrierMaskingStyled } from './styled';

const CarrierMasking = () => {
  const plan = useSelector(accountSelector);

  return (
    <CarrierMaskingStyled>
      <CustomLayoutOneThird
        isShowDivider
        title={
          <Text as="span" variant="headingMd">
            Carrier masking
          </Text>
        }
        description={
          <Text as="p" variant="bodySm" tone="subdued">
            Replace the carrier name customers see with a cleaner label
          </Text>
        }
      >
        <BlockStack gap="400">
          <UpgradeBanner
            isOpen={[AccountPlan.Starter, AccountPlan.Basic].includes(plan.plan) && !plan.isOldPaidUser}
            usedFeature={AccountPlan.Professional}
            isHiddenTitle
            feature="courier_mapping"
          />
          <MaskingRules />
        </BlockStack>
      </CustomLayoutOneThird>
    </CarrierMaskingStyled>
  );
};

export default CarrierMasking;
